import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-heading',
  standalone: true,
  templateUrl: './section-heading.component.html',
  styleUrl: './section-heading.component.scss',
})
export class SectionHeadingComponent {
  /** Mała etykieta nad tytułem (uppercase, akcent). Pomiń by ukryć. */
  @Input() eyebrow?: string;
  /** Tytuł — dopuszcza HTML (np. <br>). */
  @Input() title = '';
  /** Podtytuł pod tytułem. Pomiń by ukryć. */
  @Input() subtitle?: string;
  /** Wariant na ciemnym tle (białe teksty). */
  @Input() invert = false;
  /** Kursywa tytułu (jak w hero/CTA). */
  @Input() italic = false;
}
